import { Box, Flex, Text } from "@mantine/core";
import { NavLink } from "react-router-dom";

import { MENU_ITEMS } from "../../constants";
import styles from "./navbar.module.css";

export default function Navbar({ collapsed }: { collapsed: boolean }) {
  return (
    <Flex
      h="100%"
      direction="column"
      justify="space-between"
      bdrs="lg"
      p="xs"
      bg="primary.1"
      w={collapsed ? "70px" : "210px"}
    >
      <Box>
        {MENU_ITEMS.map((item) => (
          <NavLink
            viewTransition
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ""} ${collapsed ? styles.collapsed : ""}`
            }
          >
            <item.icon size={collapsed ? 20 : 16} />

            {!collapsed && (
              <Text fw="bold" fz="md">
                {item.label}
              </Text>
            )}
          </NavLink>
        ))}
      </Box>
    </Flex>
  );
}
